var _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3189,
    cy: 20.3189,
    r: 20.3189,
    fill: "#F3F3F3",
    fillOpacity: 0.95
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.71387,
    y: 9.71777,
    width: 21.2024,
    height: 21.2024,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABH0lEQVRIie2UsU7DMBCGv6Md/Q68AG/CgupWHUCCDQkhJiYSiQSl3ViBjaUgRWp4OmdrdQxJpDRtaUK8IHGb5fP3Wb98hr9e4gNi5lmIco9y7UKbehWYWRYBj+VyrehVHowX1f6RJ/gKWAIDQd5Nkk17CzZuLnrnAjspJUOEt6pv2BsOoHJj5ktQzgohz9XWoAd8hegtyDFwAnJKkUjsAvtU9XeKaAOuXLiH8SuiL7WW2AU2qp9p/Ypq8LWqXObh6MMkXxNEPymijlxg4+a5VoLfwlsJ+sAPCvrCfxT4gO8V+ILvFPiEbwl8w2H7qyjGXznPw1FqkmyK6KLsi7vCYc8ku9Cmxc2p4FFzQttWMyLd0dM5lnod+ot6wf+rVX0DSP6/xwA1EG4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d2043d8a2b8ab005fc4fe2ec351c2856.svg";
export { ForwardRef as ReactComponent };